import { gql } from '@apollo/client'

export const Room = gql`
    query Room($roomId: ID!) {
        room(id: $roomId) {
            admins {
                id
                username
                avatar
            }
            created
            id
            invites {
                id
                email
                issuer {
                    id
                    username
                    avatar
                }
                ttl
                user {
                    id
                    username
                    avatar
                }
            }
            members {
                id
                username
                avatar
                roles
            }
            name
            owner {
                id
                username
                avatar
            }
            djAccess
            public
            spinning
            timezone
            topic
            updated
        }
    }
`

export default Room
